const data = {
  github: {
    id: "contact-github",
    link: "https://github.com/curthenrichs",
    text: null
  },
  linkedin: {
    id: "contact-linkedin",
    link: "https://www.linkedin.com/in/curt-henrichs/",
    text: null
  },
  twitter: {
    id: "contact-twitter",
    link: "https://twitter.com/curt_henrichs",
    text: "@curt_henrichs"
  },
  bluesky: {
    id: "contact-bluesky",
    link: "https://bsky.app/profile/curt-henrichs.bsky.social",
    text: "@curt-henrichs.bsky.social"
  },
  email: {
    id: "contact-email",
    link: "mailto:curthenrichs@gmail.com",
    text: "curthenrichs@gmail.com"
  },
  location: {
    id: "contact-location",
    link: null,
    text: "San Francisco Bay Area, California, USA"
  },
  resume: {
    id: "contact-resume",
    link: "/docs/curt-henrichs-resume.pdf",
    text: "Resume"
  },
  blog: {
    id: "contact-blog",
    link: "https://www.half-built-robots.com/",
    text: "Blog (Half-Built-Robots)"
  }
};

export default data;
